import { BaseSpotComponent, SpotInputProps } from './common';
import { SpotFieldError } from './SpotFieldError';

export interface SpotToggleProps extends SpotInputProps {}

export class SpotToggle extends BaseSpotComponent<SpotToggleProps> {
    render() {
        const { className, name, error, children, id, ...rest } = this.props;
        return (
            <span className={className}>
                <input id={this.idProp} name={name} {...rest} type="checkbox" className="spot-toggle" />
                <label className="spot-toggle-label" htmlFor={this.idProp}>
                    {children}
                </label>
                {error && <SpotFieldError meta={error} />}
            </span>
        );
    }
}
